import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/partner/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/partner/detail', Object.assign({}, options, { params }))

export const remove = (params, options) =>
request.post('/api/v4ward/partner/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/partner/save', params,options)

export const update = (params, options) =>
request.post('/api/v4ward/partner/update', params,options)

//项目字典接口
export const getProjectDictionary = (params, options) =>
  request.get('/api/v4ward/projectDict/dictionary', Object.assign({}, options, { params }));
